// RITA-1498 (Nutzungserfassung Phase 1b) — sichtbare Verweildauer und Scrolltiefe (Konzept 3.3).
// Die Seite scrollt im Fenster (kein eigener Scroll-Container, siehe SiteLayout/Main.tsx),
// deshalb genügen window.scrollY, window.innerHeight und document.documentElement.scrollHeight.
export interface ScrollMetrics {
  scrollY: number;
  innerHeight: number;
  scrollHeight: number;
}

export interface PageTimerDeps {
  now: () => number;
  isVisible: () => boolean;
  getScrollMetrics: () => ScrollMetrics;
}

export interface PageTimerResult {
  visibleMs: number;
  scrollPct: number;
}

export interface PageTimer {
  start(): void;
  onVisibilityChange(): void;
  onScroll(): void;
  finish(): PageTimerResult;
}

export const scrollPercent = ({ scrollY, innerHeight, scrollHeight }: ScrollMetrics): number => {
  if (!(scrollHeight > 0) || scrollHeight <= innerHeight) return 100;
  const seen = ((Number(scrollY) || 0) + innerHeight) / scrollHeight;
  return Math.min(100, Math.max(0, Math.round(seen * 100)));
};

export const createPageTimer = ({ now, isVisible, getScrollMetrics }: PageTimerDeps): PageTimer => {
  let accumulatedMs = 0;
  let visibleSince: number | null = null;
  let maxPct = 0;

  const sample = (): void => {
    try {
      maxPct = Math.max(maxPct, scrollPercent(getScrollMetrics()));
    } catch {
      // Maße nicht lesbar: letzte Messung behalten
    }
  };

  return {
    start(): void {
      accumulatedMs = 0;
      maxPct = 0;
      visibleSince = isVisible() ? now() : null;
      sample();
    },
    onVisibilityChange(): void {
      if (isVisible()) {
        if (visibleSince === null) visibleSince = now();
      } else if (visibleSince !== null) {
        accumulatedMs += now() - visibleSince;
        visibleSince = null;
      }
    },
    onScroll: sample,
    finish(): PageTimerResult {
      sample();
      let total = accumulatedMs;
      if (visibleSince !== null) {
        const at = now();
        total += at - visibleSince;
        visibleSince = at;
      }
      accumulatedMs = 0;
      return { visibleMs: Math.max(0, Math.round(total)), scrollPct: maxPct };
    },
  };
};
